import { IBaseContact } from './IBaseContact';

export type IPresentationContactData<T, E> = T & {
  function?: E;
  role?: E;
  key: number | string;
};

export const getListOfPresentationContacts = <T, E>(
  data: IBaseContact<any>[],
  functionsOrdered: E[]
): IPresentationContactData<T, E>[] =>
  data
    .flatMap((contact) =>
      contact.functions.length === 0
        ? ({ ...contact, key: contact.id } as IPresentationContactData<any, any>)
        : contact.functions.map(
            (f) => ({ ...contact, key: `${contact.id}-${f}`, function: f } as IPresentationContactData<any, any>)
          )
    )
    .sort((a: IPresentationContactData<T, E>, b: IPresentationContactData<T, E>) => {
      //unlike ThirdPartyContactData, the function field is optional for ClientContactData.
      if (!!a.function && !!b.function) {
        return functionsOrdered.indexOf(a.function) - functionsOrdered.indexOf(b.function);
      } else if (!!a.function || !!b.function) {
        return !!a.function ? -1 : 1;
      }
      //if both a and b have undefined functions, sort by name.
      return a['firstName'].localeCompare(b['firstName']);
    });

// Helper for internal contacts that use roles instead of functions
export const getListOfPresentationContactsWithRoles = <T extends {
  roles: string[];
  id: string;
  firstName: string
}>(
  data: T[],
  rolesOrdered: string[],
): IPresentationContactData<T, string>[] =>
  data
    .flatMap((contact) => {
      return contact.roles.length === 0
        ? ({ ...contact, key: contact.id } as IPresentationContactData<T, string>)
        : contact.roles.map(
          (roleName) => ({
            ...contact,
            key: `${contact.id}-${roleName}`,
            role: roleName,
          } as IPresentationContactData<T, string>),
        );
    })
    .sort((a: IPresentationContactData<T, string>, b: IPresentationContactData<T, string>) => {
      if (!!a.role && !!b.role) {
        return rolesOrdered.indexOf(a.role) - rolesOrdered.indexOf(b.role);
      } else if (!!a.role || !!b.role) {
        return !!a.role ? -1 : 1;
      }
      return a.firstName.localeCompare(b.firstName);
    });
